import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, SvgIcon } from '@/core/ui';
import { authApi, useAuthStore } from '@/shared/modules/auth/business';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { SidebarUserAvatar, SidebarUserDataContainer, SidebarUserEmail, SidebarUserName, SidebarUserProfileButton, } from './UserProfileButton.styled';
import { t } from '@/core/localization';
import rightFromBracketIcon from '@/core/svg/fa/right-from-bracket.svg';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { useState } from 'react';
const UserProfileButton = () => {
    const collapsed = useLayoutStore((state) => state.sidebarCollapsed);
    const togglePaletteMode = useLayoutStore((state) => state.togglePaletteMode);
    const signOut = useAuthStore((state) => state.signOut);
    const { data: { userFullName, userEmail, avatar } = {} } = authApi.endpoints.getCurrentUser.useQueryState();
    const [anchorElement, setAnchorElement] = useState(null);
    const open = Boolean(anchorElement);
    const handleProfileButtonClick = (event) => {
        setAnchorElement(event.currentTarget);
    };
    const handleSignOutMenuItemClick = () => {
        signOut();
    };
    const handleClose = () => {
        setAnchorElement(null);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(SidebarUserProfileButton, { sidebarCollapsed: collapsed, menuExpanded: open, onClick: handleProfileButtonClick, children: [_jsx(SidebarUserAvatar, { alt: userFullName, image: avatar }), collapsed || (_jsxs(SidebarUserDataContainer, { children: [_jsx(SidebarUserName, { children: userFullName }), _jsx(SidebarUserEmail, { children: userEmail })] }))] }), _jsxs(Menu, { anchorEl: anchorElement, open: open, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 112, // instead of 'bottom'
                    horizontal: 'left',
                }, onClose: handleClose, children: [API_URL === 'https://ui-dev.kube.global-parts.su' && (_jsxs(_Fragment, { children: [_jsx(MenuItem, { onClick: togglePaletteMode, children: t('switch.color.scheme.label') }), _jsx(Divider, {})] })), _jsx(MenuItem, { onClick: () => { }, disabled: true, children: t('userprofile.section') }), _jsx(Divider, {}), _jsxs(MenuItem, { onClick: handleSignOutMenuItemClick, children: [_jsx(ListItemIcon, { children: _jsx(SvgIcon, { icon: rightFromBracketIcon }) }), t('sign.out.label')] })] })] }));
};
export { UserProfileButton };
